import { Inject, Component } from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { BasePetition } from '@ncessor/shared';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { PetitionEditorComponent } from './petition-editor.component';
import { MatButton } from '@angular/material/button';

export interface PetitionEditData {
  editPetition: BasePetition;
  isNewPetition: boolean;
}

@Component({
  selector: 'app-petition-edit-dialog',
  templateUrl: './petition-edit-dialog.html',
  styleUrls: ['./petition-editor.component.scss'],
  imports: [
    MatDialogTitle,
    CdkScrollable,
    MatDialogContent,
    PetitionEditorComponent,
    MatDialogActions,
    MatButton,
  ],
})
export class PetitionEditDialog {
  editPetition: BasePetition;

  constructor(
    public dialogRef: MatDialogRef<PetitionEditDialog>,
    @Inject(MAT_DIALOG_DATA) public data: PetitionEditData,
  ) {
    this.editPetition = this.data.editPetition;
  }

  ngOnInit() {}

  onSave() {
    this.dialogRef.close(this.editPetition);
  }

  onCancel() {
    this.dialogRef.close();
  }

  get title() {
    return this.data.isNewPetition ? 'Add' : 'Edit';
  }
}
